import { get, post } from '../helpers/utils/http-client';
import { APPS_ENDPOINT } from '../consts/api-endpoints';

export async function startPlaybookGeneration(appId, request) {
    const { status, response } = await post(`${APPS_ENDPOINT}/${appId}/gen-ai/playbook-gen`, request);
    if (status !== 202) throw new Error((typeof response === 'string' ? response : response?.message) || 'Could not start generation. Please try again.');
    return response;
}
export async function getPlaybookGenerationStatus(appId, journeyId) {
    const { status, response } = await get(`${APPS_ENDPOINT}/${appId}/gen-ai/playbook-gen/${journeyId}/status`);
    if (status !== 200) throw new Error((typeof response === 'string' ? response : response?.message) || 'Could not refresh generation status. Retrying…');
    return response.aiGenStatus;
}
export const isGenerationActive = status => Boolean(status && !['complete', 'failed'].includes(status.state));
